// extracted by mini-css-extract-plugin
export default {"login_wrapper":"login_login_wrapper__WLDyt","form_wrapper":"login_form_wrapper__xazeQ","form_wrapper__get_help":"login_form_wrapper__get_help__vVyin"};